// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3eLGG","buttons":"SendReceipts_buttons__3Nmry","email":"SendReceipts_email__ve3gh","bookApptTitle":"SendReceipts_bookApptTitle__3zUcp"};